import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import i18n from "../../constants/i18n";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Text from "../../core/et3-text";
import {
  WELCOME_CARD_BADGE_RADIUS,
  WELCOME_CARD_BADGE_SIZE,
  WELCOME_CARD_BORDER,
  WELCOME_CARD_GAP,
  WELCOME_CARD_HEIGHT,
  WELCOME_CARD_ICON_SIZE,
  WELCOME_CARD_LABEL_FONT_SIZE,
  WELCOME_CARD_LINK_FONT_SIZE,
  WELCOME_CARD_PADDING,
  WELCOME_CARD_PRESS_OFFSET,
  WELCOME_CARD_RADIUS,
  WELCOME_CARD_SHADOW,
  WELCOME_CARD_SHADOW_HOVER,
  WELCOME_CARD_VALUE_FONT_SIZE,
  WELCOME_CARD_WIDTH,
  WELCOME_TRANSITION
} from "./welcome-constants";

const WelcomeQueueCard = withLiteObserverAndTheme<{
  icon: IconProp;
  accent: string;
  badgeBackground: string;
  label: string;
  count: number;
  link: string;
}>((props) => {
  const { icon, accent, badgeBackground, label, count, link, theme } = props;
  const { colors, unitX, unitY } = theme;
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  const [isPressed, setIsPressed] = useState(false);

  return (
    <button
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => {
        setIsHovered(false);
        setIsPressed(false);
      }}
      onMouseDown={() => setIsPressed(true)}
      onMouseUp={() => setIsPressed(false)}
      onClick={() => navigate({ pathname: link })}
      style={{
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "space-between",
        width: WELCOME_CARD_WIDTH * unitX,
        height: WELCOME_CARD_HEIGHT * unitY,
        backgroundColor: colors.all.white,
        border: WELCOME_CARD_BORDER,
        borderRadius: WELCOME_CARD_RADIUS * unitX,
        boxShadow: isHovered ? WELCOME_CARD_SHADOW_HOVER : WELCOME_CARD_SHADOW,
        transform: `translateY(${
          isPressed ? WELCOME_CARD_PRESS_OFFSET * unitY : 0
        }px)`,
        transition: WELCOME_TRANSITION,
        padding: WELCOME_CARD_PADDING * unitX,
        gap: WELCOME_CARD_GAP * unitY,
        cursor: "pointer",
        textAlign: "left"
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: WELCOME_CARD_GAP * unitX,
          width: "100%"
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            width: WELCOME_CARD_BADGE_SIZE * unitX,
            height: WELCOME_CARD_BADGE_SIZE * unitY,
            borderRadius: WELCOME_CARD_BADGE_RADIUS * unitX,
            backgroundColor: badgeBackground
          }}
        >
          <FontAwesomeIcon
            icon={icon}
            color={accent}
            style={{
              width: WELCOME_CARD_ICON_SIZE * unitX,
              height: WELCOME_CARD_ICON_SIZE * unitY
            }}
          />
        </div>
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={WELCOME_CARD_LABEL_FONT_SIZE}
          text={label}
          isSpan={false}
          color={colors.all.maastrichtBlue}
          style={{ margin: 0, textAlign: "left" }}
        />
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "space-between",
          width: "100%"
        }}
      >
        <Et3Text
          fontFamily={"BOLD"}
          fontSize={WELCOME_CARD_VALUE_FONT_SIZE}
          text={`${count}`}
          isSpan={false}
          color={colors.all.maastrichtBlue}
          style={{ margin: 0 }}
        />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: (WELCOME_CARD_GAP / 2) * unitX,
            opacity: isHovered ? 1 : 0,
            transition: WELCOME_TRANSITION
          }}
        >
          <Et3Text
            fontFamily={"MEDIUM"}
            fontSize={WELCOME_CARD_LINK_FONT_SIZE}
            text={i18n.get("OPEN_QUEUE")}
            isSpan={false}
            color={accent}
            style={{ margin: 0, whiteSpace: "nowrap" }}
          />
          <FontAwesomeIcon
            icon={faArrowRight}
            color={accent}
            style={{
              width: WELCOME_CARD_LINK_FONT_SIZE * unitX,
              height: WELCOME_CARD_LINK_FONT_SIZE * unitY
            }}
          />
        </div>
      </div>
    </button>
  );
});
export default WelcomeQueueCard;
